<template>
  <v-btn-toggle
    style="margin: 0px; border-radius: 5px;"
    class="pa-1"
    v-model="navigationMode"
    @change="setNavigationMode"
  >
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" class="zoom-button" value="pan" flat>
          <v-icon size="20">mdi-pan</v-icon>
        </v-btn>
      </template>
      <span>Panoreringsmodus</span>
    </v-tooltip>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" class="zoom-button" value="rotate" flat>
          <v-icon size="20">rotate_left</v-icon>
        </v-btn>
      </template>
      <span>Tiltemodus</span>
    </v-tooltip>
  </v-btn-toggle>
</template>

<script>
import { loadModules } from "esri-loader";
export default {
  name: "MapPanRotateToggleNavigation",
  data: function() {
    return {
      navigationToggleViewModel: null,
      currentOrientation: 0,
      navigationMode: "pan"
    };
  },
  methods: {
    setNavigationMode: function() {
      this.navigationToggleViewModel.toggle();
    },

    loadNavigationToggle: function() {
      loadModules([
        "esri/widgets/NavigationToggle/NavigationToggleViewModel"
      ]).then(
        function([NavigationToggleViewModel]) {
          this.navigationToggleViewModel = new NavigationToggleViewModel({
            view: this.$theSceneViewObject
          });
        }.bind(this)
      );
    }
  },
  mounted() {
    this.loadNavigationToggle();
  }
};
</script>

<style>
.vertical-v-btn-toggle {
  flex-direction: column;
}
</style>
